export enum SuppliersBalanceSortProperty {
  AccountNumber = 'auxiliaryAccountNo',
  Name = 'contactName',
  Balance = 'balance',
  LastPeriod = 'comparisonBalance',
  Variance = 'variance',
  VariancePercentage = 'variancePercent',
}
